import { I18n } from 'react-i18nify'
import en from './locales/en'
import fr from './locales/fr'
import de from './locales/de'


I18n.setTranslations({ en, fr, de })

export * from 'react-i18nify'
export default I18n
